<template>
    <el-row>
      <el-col :span="24">
        <div class>
      <div class="center">
        <div class="top" >
          <div class="t1">科技成果转化服务流程</div>
          <h1 class="tit" id="scroll-target1">以需求为导向</h1>
          <div class="text">
            <div class="b1">组织开展企业需求挖掘</div>
            <div class="singleArrow"></div>
            <div class="b2">
              <div class="bb1">
                <p>调研筹备</p>
                <div class="l1">
                  <span class="sp1">企业名称</span>
                  <span class="sp2">企业介绍</span>
                  <span class="sp3">技术需求信息表</span>
                  <span class="sp1">调研时间</span>
                  <span class="sp2">调研团队</span>
                  <span class="sp4">其他</span>
                </div>
              </div>
              <div class="bb2">通过当地政府平台了解该领域相关项目支持政策</div>
            </div>
            <div class="b3">
            <div class="singleArrow"></div>
            <div class="wz1">通过检索河南省科技成果转移转化平台企业需求库中信息，准备企业调研资料</div>
            <div class="singleArrow"></div>
            <div class="wz1">通过当地科技局主管科室与企业联系,调研团队进入企业调研资料</div>
            </div>
            <div class="b4">
            <div class="singleArrow1"></div>
            <div class="wz2">与企业相关人员沟通企业需求情况，并做好记录</div>
            <div class="singleArrow2"></div>
            <div class="wz3">根据企业实际调研的需求情况，通过线上成果智能匹配和线下成果资源渠道遴选相应成果方</div>
            <div class="singleArrow2"></div>
           
            <div class="wz4"> 
              <p>企业调研总结</p>
                  <div class="spf">企业介绍</div>
                  <div class="sp">交谈需求结束</div>
                  <div class="sp">现场交流图片</div>
                  <div class="sp">后期可能对接资源和政策</div>
                </div>
            <div class="singleArrow3"></div> 
          </div>
          <div class="b5">
           <span>技术转移补助政策</span>
           <span>高企补助政策</span>
           <span>科技创新券补助政策</span>
           <span>科技金融补助政策</span>
           <span>研发加计扣除补助政策</span>
           <span>重点实验室补助政策</span>
           <span>重大专项补助政策</span>
           <span>其他补助政策</span>

          </div>
          <div class="b6">
            <div class="t1">
              <h4>根据企业需求情况要求，联系成果方出相应的简易解决方案</h4>
              <span>需求解决方案</span>
              <span>实施周期</span>
              <span>实施周期</span>
              <span>方案预算</span>
              </div>
             <div class="singleArrow4"></div>
             <div class="singleArrow5"></div>
             <div class="box1">与项目相关科技补助政策查询及整理</div>
             <div class="singleArrow6"></div>
             <div class="box2">综合形成全要素解决方案与企业需求方沟通</div>
             <div class="singleArrow7"></div>
             <div class="box3">双方合作签约</div>
             <div class="singleArrow7"></div>
             <div class="box3">技术合同登记备案</div>
          </div>
          <div class="singleArrow8"></div>
          <div class="box44">技术合同登记备案</div>
          </div>
            </div>
            <div class="middle" >
     
             
              <div  class="t1" >科技成果转化服务流程</div>
          <h1 class="tit"  >以成果为导向</h1>
          <div class="text">
            <div class="b1" id="resultDiv">梳理我省重点产业领域技术需求，确立成果征集方向</div>
            <div class="singleArrow"></div>
            <div class="b2">
              <span>由政府指导进行常态化征集</span>
              <span>组织人员深入高校院校征集</span>
            </div>
            <div class="b3">
            <div class="box1">
                作为需求匹配资源入库备用
             </div>
             <div class="singleArrow1"></div>
<div class="box2">
  商务谈判
</div>
<div class="singleArrow"></div>
<div class="box3">
  合作签约
</div>
            </div>
            <div class="singleArrow2"></div>
            <div  class="b4">建设可转化成果库</div>
            <div class="singleArrow3"></div>
            <div class="b5">组织概念验证</div>
            <div class="singleArrow4"></div>
            <div class="b6">常态化成果宣传、推介、路演</div>
            <div class="singleArrow5"></div>
            <div class="b7">成果评价</div>
            <div class="singleArrow6"></div>
            <div class="b8">潜在合作对象洽谈对接</div>
            <div class="singleArrow7"></div>
            <div class="singleArrow8"></div>
            <div class="b9">合同登记备案</div>
          </div>
      
            </div>
      </div>
      <div class="bottom">
        <img src="../../../assets/library/chengguo/组 25083@2x.png" alt />
        </div>
        </div>
      </el-col>
    </el-row>
  </template>
  
  <script>

 
  export default {
    created(){
      this.$nextTick(()=>{
        console.log(this.$route.query)
        if(this.$route.query.type == '0'){
          var anchor = this.$el.querySelector('#resultDiv')
      document.documentElement.scrollTop = anchor.offsetTop
        }
        
      })
      
    },
    
    mounted(){
      const target = document.getElementById('scroll-target')
    window.scrollTo(0, target.offsetTop)
   
    const targett = document.getElementById('scroll-target1')
    window.scrollTo(0, targett.offsetTop)
    }
  }
  </script>
  
  <style lang="scss" scoped>
 .center{
    margin-left: 10rem;
    .top{
      text-align: center;
        margin-top: 2rem;
        height:48rem; 
      .text{
        width: 95rem;
        height: 40rem;
        margin-top: 2rem;
        background-color: #F6F6F6 ;
        border: 1px dashed #000;
        padding: 2rem;
        .b1{
          width: 1.3rem;
          height: 16.5rem;
          padding-top: 3.5rem;
          color: white;
          padding-left: 1rem;
          padding-right: 1rem;
          display: inline;
          float: left;
          background: linear-gradient( 180deg, #5A96FF 0%, #2769DC 100%);
        }
        .b2{
          width: 15.5rem;
          height:20rem;
          // background-color: rebeccapurple ;
          display: inline;
          float:left;
          margin-left: 2rem;
          .bb1{
            width: 15.5rem;
            height: 15rem;
            border: 1.5px dashed #2769DC;
            background-color: #ECF2FF ;
            p{
              color: #2769DC;
              font-weight: bold;
              text-align: left;
              font-size: 1.3rem;
              margin-left: 1.5rem;
              margin-top: 1.5rem;
            }
            .l1{
              text-align: left;
              margin-top: 1rem;
              .sp1{
                border: 1.5px solid #2769DC;
                border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
                background-color: #F6F6F6;
                // margin-right:2rem ;
                color: #2769DC;
                padding-left:1rem;
                padding-right: 1rem;
                padding-top: 0.2rem;
                padding-bottom: 0.2rem;
                margin-left:1.5rem;
                // margin-left:0.65rem;
              }
              .sp2{
                border: 1.5px solid #2769DC;
                border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
                background-color: #F6F6F6;
                // margin-right:2rem ;
                color: #2769DC;
                padding-left:1rem;
                padding-right: 1rem;
                padding-top: 0.2rem;
                padding-bottom: 0.2rem;
                margin-left:1rem;
                // margin-left:0.65rem;
              }
              .sp3{
                width:9.1rem;
                border: 1.5px solid #2769DC;
                border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
                background-color: #F6F6F6;
                text-align: center;
                color: #2769DC;
                padding-left:2rem;
                padding-right: 2rem;
                padding-top: 0.2rem;
                padding-bottom: 0.2rem;
                margin-left:1.5rem;
                margin-top: 1rem;
                margin-bottom: 1rem;
                display: block;
              }
              .sp4{
                width:4rem;
                border: 1.5px solid #2769DC;
                border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
                background-color: #F6F6F6;
              text-align: center;
                color: #2769DC;
                padding-left:1rem;
                padding-right: 1rem;
                padding-top: 0.2rem;
                padding-bottom: 0.2rem;
                margin-left:1.5rem;
                display: block;
                margin-top: 1rem;
              }
            }
          }
          .bb2{
            width: 14.5rem;
            height: 2.8rem;
            margin-top: 1rem;
            color: #2769DC;
            padding: 0.5rem;
            background-color: #F6F6F6;
            border: 1.5px solid #2769DC;
            text-align: left;
          }
        }
        .b3{
          height: 20rem;
          margin-left:22rem;
          display: inline;
          .wz1{
            width:4.5rem;
            height:13rem;
            margin-left:2rem;
            float: left;
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            padding-top: 2rem;
            border: 1.5px solid #2769DC;
            background-color: white;
            color: #2769DC;
          }
        }
        .b4{
          width:37.5rem;
          height: 20rem;
          margin-left:2rem;
          display: inline;
          float:right;
          .wz3{
            width: 15rem;
            height: 4.5rem;
            border: 1.5px solid #23AABC;
            background-color: white;
            color: #23AABC;
            padding-top: 1rem;
            padding-left: 1rem;
            padding-right: 1rem;
            margin-top: 5rem;
            text-align: left;
          }
          .wz2{
            width: 15rem;
            height: 3.5rem;
            background-color: white;
            color: #2769DC;
            border: 1.5px solid #2769DC;
            padding-top: 1rem;
            padding-left: 1rem;
            padding-right: 1rem;
            text-align: left;
          }
          .wz4{
            width: 14rem;
            height: 16rem;
            display: inline;
          float:right;
          margin-top: -15.4rem;
          background-color: #F8F1FF  ;
          border: 1.5px dashed #9B4AEC;
          // opacity:0.2;
          p{
            color: #9B4AEC;
              font-weight: bold;
              text-align: left;
              font-size: 1.3rem;
              margin-left: 1.5rem;
              margin-top: 1.5rem;
          }
          .sp{
            border: 1.5px solid #9B4AEC;
                border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
                background-color: #F6F6F6;
                width: 7rem;
                // margin-right:2rem ;
                color: #9B4AEC;
                padding-left:0.5rem;
                padding-right: 1rem;
                padding-top: 0.2rem;
                margin-top: 1rem;
                margin-left:1.7rem;
                padding-bottom: 0.2rem;
             
          }
          .spf{
            border: 1.5px solid #9B4AEC;
                border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
                background-color: #F6F6F6;
                width: 5rem;
                // margin-right:2rem ;
                color: #9B4AEC;
                padding-left:0.5rem;
                padding-right: 1rem;
                padding-top: 0.2rem;
                margin-top:0.5rem;
                margin-left:1.7rem;
                padding-bottom: 0.2rem;
             
          }
          }
        }
        .b5{
          width: 26rem;
          height: 16rem;
          background-color: #E8FCFF;
          margin-top: 24rem;
          border: 1.5px dashed #23AABC ;
       
          span{
            width: 10rem;
            border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
            margin-left: 1.5rem;
            padding: 0.3rem;
            color: #23AABC;
            border: 1.5px solid #23AABC;
            background: white;
            display:block;
            float: left;
            text-align: center;
            margin-top: 1.45rem;
          }
        }
        .b6{
          width:59rem;
          height: 20.4rem;
          display: inline;
          float:left;
          margin-top: -19.3rem;
          margin-left:27rem;
          .t1{
            width: 35rem;
            height: 7rem;
            border:1.5px dashed #23AABC ;
            background-color: #E8FCFF ;
            margin-left: 10rem;
            h4{
              margin-top: 2rem;
              color: #23AABC;
            }
            span{
              width: 10rem;
              margin-left: 1.5rem;
              padding: 0.3rem;
              font-size: 16px;
              margin-top: 1rem;
              border-radius: 0.33rem 0.33rem 0.33rem 0.33rem;
              border:1.5px solid #23AABC ;
              background-color: white;
            }
          }
      .box1{
            width: 9.5rem;
            height: 2.5rem;
            display: block;
            float: left;
            margin-left: -24rem;
            background: white;
            padding: 1rem;
            margin-top: 7.5rem;
            color: #23AABC;
            border:1.5px solid #23AABC ;
           }
      .box2{
            width:10rem;
            height: 2.5rem;
            display: block;
            float: left;
            margin-left: -6.5rem;
            background: white;
            padding: 1rem;
            margin-top: 7.5rem;
            color: #23AABC;
            border:1.5px solid #23AABC ;
            }
          .box3{
            width:3rem;
            height:3.5rem;
            display: block;
            float: left;
            margin-left: 2.2rem;
            background: white;
            padding: 1rem;
            margin-top: 6.5rem;
            color: #23AABC;
            line-height: 1.5rem;
            border:1.5px solid #23AABC;
          }
         
         
        }
        .singleArrow {
		width:3rem;
		height: 20px;
    margin-top:6rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:1rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow1 {
		width:3rem;
		height: 20px;
    margin-top:3rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left: -5rem;
    		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow1::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow2 {
		width:3rem;
		height: 20px;
    margin-top:1.5rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left: 100rem;
    margin-left: 7rem;
    		 transform: rotate(90deg); 
	}
	.singleArrow2::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow3 {
		width:3rem;
		height: 20px;
    margin-top:-11.8rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:8rem;
    		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow3::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow4 {
		width:3rem;
		height: 20px;
    margin-top:2rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:26rem;
    // margin-left: 7rem;
    		 transform: rotate(90deg); 
	}
	.singleArrow4::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow5 {
		width:3rem;
		height: 20px;
    margin-top:8.9rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:-29rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow5::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow6 {
		width:3rem;
		height: 20px;
    margin-top:9rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:-11.5rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow6::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow7 {
		width:3rem;
		height: 20px;
    margin-top:9rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:0.5rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow7::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow8 {
		width:3rem;
		height: 20px;
    margin-top:-3rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:-2rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow8::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
      }
        .t1{
         font-size: 1.2rem;
         font-weight:bold;
         margin-right: 13rem;
        }
        .tit{
          width:16rem;
          padding: 0.5rem;
          background-color: #2769DC;
          color: white;
          font-size: 1.3rem;
          margin-left: 40rem;
          border-radius: 2.42rem 2.42rem 2.42rem 2.42rem;
        }
    }
    .middle{
        width: 99.2rem;
        height: 40rem;
        margin-top: 10rem;
       .t1{
         font-size: 1.2rem;
         font-weight:bold;
         margin-right: 3rem;
        }
        .tit{
          width:16rem;
          padding: 0.5rem;
          background-color: #2769DC;
          color: white;
          font-size: 1.3rem;
          margin-left: 40rem;
          border-radius: 2.42rem 2.42rem 2.42rem 2.42rem;
        }
        .text{
        width: 95rem;
        height: 20rem;
        margin-top: 2rem;
        background-color: #F6F6F6 ;
        border: 1px dashed #000;
        padding: 2rem;
        .b1{
          width: 4.3rem;
          height: 16.5rem;
          padding-top: 3.5rem;
          color: white;
          padding-left: 1rem;
          padding-right: 1rem;
          display: inline;
          float: left;
        font-size: 1.3rem;
          background: linear-gradient( 180deg, #5A96FF 0%, #2769DC 100%);
        }
        .b2{
          width: 20rem;
          height: 6rem;
          border: 1.5px dashed #2769DC;
            background-color: #ECF2FF ;
          display: block;
          padding: 1rem;
          float:left;
          margin-left: 2rem;
          span{
            width:18rem;
            padding: 0.5rem;
            margin-left: 0.4rem;
            margin-bottom: 1rem;
            border: 1.5px solid #2769DC;
            display: block;
            color: #2769DC;
            background-color: white;
          }
        }
        .b3{
          width: 42rem;
          height: 8rem;
          display: block;
          float: right;
          margin-right: -0.5rem;
          .box1{
            width:9rem;
            height: 3rem;
            background-color: white;
            padding: 1rem;
            margin-top:2.7rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
            text-align: left;
            display: block;
            float: left;
          }
          .box2{
            width:9rem;
            height: 3rem;
            background-color: white;
            padding-top: 2rem;
            margin-top:2.7rem;
            margin-left: 1.5rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
            text-align: center;
            display: block;
            float: left;
          }
          .box3{
            width:9rem;
            height: 3rem;
            background: linear-gradient( 180deg, #5A96FF 0%, #2769DC 100%);
            padding-top: 2rem;
            margin-top:2.7rem;
            border: 1.5px solid #2769DC;
            color: white;
            text-align: center;
            display: block;
            float: right;
          }
          .singleArrow {
		width:3rem;
		height: 20px;
    margin-top:4.85rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:1rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
          }
          .b4{
            width: 15rem;
            height:3rem;
            margin-left: 12.3rem;
            margin-top: 15rem;
            background-color: white;
            padding-top: 2rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
            
          }
          .b5{
            width:4rem;
            height:4rem;
            margin-left:-22rem;
            margin-top: -5.1rem;
            background-color: white;
            padding-left: 2rem;
            padding-top: 1rem;
            padding-right: 2rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
          display: inline-block;
          }
          .b6{
            width:7rem;
            height:4rem;
            margin-left:59rem;
            margin-top: -5.2rem;
            background-color: white;
            padding-left: 2rem;
            padding-top: 1rem;
            padding-right: 2rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
    

          }
          .b7{
            width:4rem;
            height:3.5rem;
            margin-left:46rem;
            margin-top: -5.06rem;
            background-color: white;
            padding-left: 2rem;
            padding-top: 1.5rem;
            padding-right: 2rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
          // display: inline-block;
  
          }
          .b8{
            width: 5rem;
            height:4rem;
            margin-left:75rem;
            margin-top: -5.06rem;
            background-color: white;
            padding-left: 1rem;
            padding-top: 1rem;
            padding-right: 1rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
          // display: inline-block;
  
          }
          .b9{
            width:4rem;
            height:3.5rem;
            margin-left:86rem;
            margin-top: -5.06rem;
            background-color: white;
            padding-left: 2rem;
            padding-top: 1.5rem;
            padding-right: 2rem;
            border: 1.5px solid #2769DC;
            color: #2769DC;
          // display: inline-block;
  
          }

          .singleArrow {
		width:3rem;
		height: 20px;
    margin-top:3.5rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:1rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
        .singleArrow1 {
		     width:3rem;
		     height: 20px;
         margin-top:4.8rem;
		     position: relative;
		    background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
        display: inline;
       float:left;
    margin-left:2rem;
		 transform: rotate(180deg);  /* 旋转角度 */
	}
	.singleArrow1::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow2 {
		     width:3rem;
		     height: 20px;
         margin-top:9.8rem;
		     position: relative;
		    background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
        display: inline;
       float:left;
    margin-left:-17rem;
		 transform: rotate(90deg);  /* 旋转角度 */
	}
	.singleArrow2::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow3 {
		width:3rem;
		height: 20px;
    margin-top:-3rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:28rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow3::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow4 {
		width:3rem;
		height: 20px;
    margin-top:-3rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:41.5rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow4::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow5 {
		width:3rem;
		height: 20px;
    margin-top:-3rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:54.5rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow5::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow6 {
		width:3rem;
		height: 20px;
    margin-top:-3rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:70.5rem;
		/* transform: rotate(-40deg); */  /* 旋转角度 */
	}
	.singleArrow6::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow7 {
		width:3rem;
		height: 20px;
    margin-top:-8rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:76.5rem;
		transform: rotate(-90deg);   /* 旋转角度 */
	}
	.singleArrow7::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
  .singleArrow8 {
		width:3rem;
		height: 20px;
    margin-top:-9rem;
		position: relative;
		background:linear-gradient( 270deg, #A7C5FF 0%, #F6F6F6 100%);
    display: inline;
    float:left;
    margin-left:88.5rem;
		transform: rotate(-270deg);   /* 旋转角度 */
	}
	.singleArrow8::after {
		content: '';
		display: block;
		position: absolute;
		right: -20px;  /* 箭头位置 */
		top: -10px;  /* 箭头位置 */
		border-top: 20px solid transparent; 	/* 箭头高低 */
		border-bottom: 20px solid transparent; /* 箭头高低 */
		border-left: 20px solid #A7C5FF; /* 箭头长度*/
	}
      }
        
    }
 }
 .bottom{

    width:100%;
        height: 50rem;
    img{
        width: 100%;
        height: 100%;
    }
 }
 .box44{   
            width:3rem;
            height:3.5rem;
            display: block;
            float: right;
            background: white;
            padding: 1rem;
            margin-top: -5.5rem;
            color: #23AABC;
            line-height: 1.5rem;
            border:1.5px solid #23AABC;
            }
  </style>